import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ReactComponent as Notfound } from "../../assets/images/notFound.svg";

function PageNotFound() {
  const navigate = useNavigate();
  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center  h-auto"
      >
        <div className="w-full h-full flex flex-col justify-center items-center bg-white  mx-auto text-center">
          <div className="w-[35%]">
            <Notfound />
          </div>
          <div className=" flex items-center gap-5">
            <NavLink to="/main/standard">
              <button
                className=" bg-primary px-2 text-white py-1 rounded-md"
                style={{ border: "1px solid #7030A0" }}
              >
                Home
              </button>
            </NavLink>
            <button
              onClick={() => navigate(-1)}
              className=" px-3 text-primary py-1 rounded-md "
              style={{ border: "1px solid #7030A0" }}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default PageNotFound;
